import React from "react";
import { Modal } from "react-bootstrap";
import LobOrderRejectIcon from "@frameworks/shared-library/assets/images/features/Markets/Pms/lob-order-reject.svg";
import ReasonSelection from "./ReasonSelection";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { orderRejectionTypes } from "../constants";
import Loader from "@frameworks/shared-library/components/Loader";
var OrderReject = function (_a) {
    //
    var _b, _c;
    var show = _a.show, setShow = _a.setShow, onClickCancel = _a.onClickCancel, reason = _a.reason, setReason = _a.setReason, selectedValue = _a.selectedValue, setSelectedValue = _a.setSelectedValue, onClickSubmit = _a.onClickSubmit, loading = _a.loading;
    var onChange = function (event) {
        var value = event.target.value;
        setReason(value);
    };
    var onClickGoBack = function () {
        setSelectedValue({ label: "", value: "" });
    };
    return (React.createElement(Modal, { show: show, setShow: setShow, backdrop: true, centered: true, contentClassName: "custom-modal-content", className: "order-modal" },
        React.createElement("span", { className: "close-container", onClick: function () {
                setShow(false);
                setSelectedValue({ label: "", value: "" });
            } },
            React.createElement("i", { className: "edel-icon-close" })),
        React.createElement("img", { src: LobOrderRejectIcon, alt: "reject-image", className: "reject-image" }),
        React.createElement("p", { className: "title" },
            "Please select the reasons for rejecting",
            React.createElement("br", null),
            "the orders."),
        (selectedValue.value == "" || selectedValue.value != "Others") && (React.createElement(ReasonSelection, { placeholder: "Select Rejection Reason", options: orderRejectionTypes === null || orderRejectionTypes === void 0 ? void 0 : orderRejectionTypes.map(function (item) { return ({
                label: item,
                value: item,
            }); }), selected: selectedValue, onChange: function (data) {
                setSelectedValue(data);
            } })),
        (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) == "Others" && (React.createElement("div", { className: "reject-container" },
            React.createElement("textarea", { name: "reason", id: "reason", value: reason, className: "reject-reason", placeholder: "Start typing the rejection reason", onChange: onChange, maxLength: 200 }),
            React.createElement("p", { className: "word-count" },
                reason.length || 0,
                "/200"))),
        loading && React.createElement(Loader, null),
        React.createElement("div", { className: "button-container" },
            selectedValue.value ? (React.createElement(EdButton, { btnTyp: "tomato-rounded", value: "Go Back", slim: true, type: "button", className: "partner-proceed rounded-pill cancel-button", onClick: onClickGoBack })) : (React.createElement(EdButton, { btnTyp: "tomato-rounded", value: "Cancel", slim: true, type: "button", className: "partner-proceed rounded-pill cancel-button", onClick: onClickCancel })),
            React.createElement(EdButton, { btnTyp: ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) == "Others" && reason.length != 0) ||
                    (((_b = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                        (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) != "Others")
                    ? "tomato"
                    : "midnight-blue", type: "button", value: "Submit", slim: true, className: "partner-proceed rounded-pill submit-button", disabled: ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) == "Others" && reason.length != 0) ||
                    (((_c = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                        (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) != "Others")
                    ? false
                    : true, onClick: onClickSubmit }))));
};
export default OrderReject;
